'use strict';

let formatters = {
    'usd' : new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    }),
    'cad' : new Intl.NumberFormat('en-CD', {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2
    }),
    'eur' : new Intl.NumberFormat('en-EU', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2
    }),
    'nzd' : new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: 'NZD',
        minimumFractionDigits: 2
    }),
    'aud' : new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2
    }),
    'gbp' : new Intl.NumberFormat('en-UK', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 2
    }),
    'jpy' : new Intl.NumberFormat('ja-JP', {
        style: 'currency',
        currency: 'JPY',
        minimumFractionDigits: 0
    }),
    'sek' : new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        minimumFractionDigits: 2
    })
};

exports.formatPrice = (region, amount) => {
    let convertedAmount = (region === "jpy") ? amount : amount / 100.0;
    return formatters[region] ? formatters[region].format(convertedAmount) : convertedAmount;
}